<template>
  <div class="sub-menu-delivery sub-menu">
    <!-- Geo content -->
    <div
      v-if="content?.delivery?.geo"
      class="sub-menu-delivery__geo sub-menu-delivery__section"
    >
      <p
        class="
          text-desktop-14-desktop
          text-mobile-12-mobile
          sub-menu-delivery__title
        "
        v-text="geoSectionTitle"
      />

      <!-- Upper geo bullet list -->
      <div
        class="
          text-desktop-14-desktop
          text-mobile-12-mobile
          sub-menu-delivery__geo-content rte
        "
        v-html="content.delivery.geo"
      />
    </div>

    <!-- Returns content -->
    <div
      v-if="content?.delivery?.returns_content"
      class="sub-menu-delivery__returns sub-menu-delivery__section"
    >
      <p
        class="
          text-desktop-14-desktop
          text-mobile-12-mobile
          sub-menu-delivery__title
        "
        v-text="$string('product.sub_menu_content.returns')"
      />

      <p
        class="text-desktop-14-desktop text-mobile-12-mobile"
        v-html="content.delivery.returns_content"
      />
    </div>

    <!-- Exchanges content -->
    <div
      v-if="content?.delivery?.exchanges_content"
      class="sub-menu-delivery__exchanges sub-menu-delivery__section"
    >
      <p
        class="
          text-desktop-14-desktop
          text-mobile-12-mobile
          sub-menu-delivery__title
        "
        v-text="$string('product.sub_menu_content.exchanges')"
      />

      <p
        class="text-desktop-14-desktop text-mobile-12-mobile"
        v-html="content.delivery.exchanges_content"
      />
    </div>

    <!-- Links content -->
    <div
      v-if="content?.delivery?.links?.items?.length"
      class="sub-menu-delivery__links"
    >
      <clickable-list
        ref="deliveryLinks"
        display-icons
        :links="content.delivery.links.items"
        @mouseleave="resetList"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Sub menu delivery
 * -----------------------------------------------------------------------------
 * Delivery & returns sub menu component.
 *
 * @param {Object} content - Content to be displayed.
 *
 */
import { mapState } from 'vuex'

import ClickableList from '~global/clickable-list/clickable-list'

export default {
  name: 'SubMenuDelivery',

  components: {
    ClickableList,
  },

  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      geolocation: (state) => state['multi-store'].geolocation,
    }),

    /**
     * Returns an appropriate string as the geo title.
     * @returns {String}
     */
    geoSectionTitle() {
      if (!this.geolocation?.name) {
        return this.$string('product.sub_menu_content.shipping')
      }

      return this.$string('product.sub_menu_content.shipping_to', {
        replace: {
          country: this.geolocation.name,
        },
      })
    },
  },

  methods: {

    /**
     * Resets the linklist in the component on mouseleave.
     */
    resetList() {
      const links = this.$refs.deliveryLinks

      if (!links) {
        return
      }

      links.resetComponentData()
    },
  },
}
</script>
